const messages = {
  seasons: {
    all: "All Season",
    summer: "Sommer",
    winter: "Winter",
    general: "General",
  },
  offer:
    "Wir erweitern regelmäßig unser <br />Angebot für Sie! <br /><br />Über neue Trainings informieren <br />wir Sie in Ihrem Postfach.",
  summary: {
    congratulations: "HERZLICHEN GLÜCKWUNSCH - SIE HABEN IHR EXPERTENWISSEN ZU",
    participation: "Sie haben erfolgreich am {name} teilgenommen.",
    certificate:
      "Ihr Zertifikat erhalten Sie per E-Mail oder können es auch hier direkt als PDF herunterladen:",
    send: "Zertifikat herunterladen",
  },
  online: {
    title: "Unsere Online-Trainings",
    desc: "Sichern sie sich Expertenwissen und bei erfolgreicher Teilnahme an den jeweiligen Tests zum Training Ihr<br> persönliches Teilnahme-Zertifikat sowie einmalig 40 Extrapunkte für den Prämienclub",
    short_desc:
      "Sichern sie sich Expertenwissen und bei erfolgreicher Teilnahme an den jeweiligen Tests zum Training Ihr<br> persönliches Teilnahme-Zertifikat sowie einmalig 40 Extrapunkte für den Prämienclub",
    content:
      "Jetzt unsere aktuellen Online-Trainings entdecken und sofort hier auf der Plattform teilnehmen:",
    categories: {
      title: "Online-Trainings",
      description:
        "Sichern Sie sich Expertenwissen und bei erfolgreicher Teilnahme an den jeweiligen Tests zum Training Ihr persönliches Teilnahme-Zertifikat sowie einmalig 40 Extrapunkte für den Prämienclub.",
      general: {
        title: "Allgemein",
        subtitle: "Online-Trainings: Allgemein",
        description:
          "Entdecken Sie die neusten Technologien, wichtige Entwicklungen in der Reifen-branche, Tipps für Ihr Verkaufsgespräch und mehr.",
        subdesription:
          "Sichern sie sich Expertenwissen und bei erfolgreicher Teilnahme an den jeweiligen Tests zum Training Ihr persönliches Teilnahme-Zertifikat sowie einmalig 40 Extrapunkte für den Prämienclub",
      },
      product: {
        title: "Produkte",
        subtitle: "Online-Trainings: Produkte",
        description:
          "Vertiefen Sie mit unseren kompakten Trainingsvideos Ihre Bridgestone und Firestone Produkt-Expertise für den erfolgreichen Abverkauf.",
        subdesription:
          "Sichern sie sich Expertenwissen und bei erfolgreicher Teilnahme an den jeweiligen Tests zum Training Ihr persönliches Teilnahme-Zertifikat sowie einmalig 40 Extrapunkte für den Prämienclub",
      },
    },
  },
  lectures: {
    title: "Bridgestone Schulungen",
    desc: "Bauen Sie Ihr Expertenwissen weiter aus und buchen Sie unsere Schulungen und Intensiv-Trainings für sich und Ihr Team. Sie haben dabei die Möglichkeit, an den Schulungen im Bridgestone Kompetenz- und Training-Center in Dietzenbach (bei Frankfurt am Main) teilzunehmen oder bei ausgewählten Schulungen diese auch bei Ihnen im Betrieb durchführen zu lassen. Sie können für die Schulungen Ihre Prämienpunkte einsetzen und damit so die Kosten ganz oder teilweise mit Ihren Punkten verrechnen.",
    content:
      "Jetzt unsere aktuellen Schulungen entdecken und Buchung anfragen:",
  },
  singleLecture: {
    registerForm: {
      title: "Inhalte der Schulung",
      inquiry: "Anfrage",
      interested: "Ich interessiere mich für die Schulung",
      participantsNr: "Teilnehmerzahl",
      pointsFromBalance:
        "Ich möchte Punkte von meinem Punkteguthaben einsetzen.",
      reduction: "Dies entspricht einer Kostenreduzierung von {points} Euro.",
      request: "Anfrage senden",
    },
    success: {
      thanks: "Vielen Dank",
      title: "Ihre Anfrage wurde an das Schulungsteam gesendet.",
      feedbackTime:
        "Sie erhalten innerhalb von 14 Tagen eine Rückmeldung zur Klärung aller<br />Details.",
      points:
        "Die eingesetzten Prämienpunkte i.H.v.<br /><strong>{points}</strong> Punkten wurden Ihrem<br />Punktekonto abgezogen.",
      refund:
        "Sollte die Schulung nicht zustande kommen, werden Ihnen die Punkte<br />selbstverständlich wieder gutgeschrieben.",
      queries: "Für Rückfragen wenden Sie sich bitte an:",
    },
    index: {
      costs: "Kosten und Teilnahmeinformationen",
      duration: "Dauer: {duration}",
      cost: "Kosten {cost}: {price} Euro ({points} punkten)",
      participantsNr: "Teilnehmerzahl: mind. {min} -max. {max} Personen",
    },
  },
  index: {
    title: "Trainings & Schulungen",
    desc: "Vorsprung durch Wissen: Sichern Sie sich mit unseren Trainingsangeboten exklusives Fachwissen für Sie und Ihr Team. Ob mit unseren Online-Trainings, an denen Sie direkt ihr auf der Plattform  teilnehmen können, mit unseren Schulungen und Praxisseminaren im Bridgestone Trainingscenter oder auch mit externen Trainings, deren Kosten Sie mit Ihren Prämienpunkten reduzieren können.",
    online: {
      title: "Online-Trainings",
      desc: "Online-Trainings entdecken und Einblicke in die Produktwelt von Bridgestone gewinnen!",
      short_desc:
        "Online-Trainings entdecken und Einblicke in die Produktwelt von Bridgestone gewinnen!",
    },
    lectures: {
      title: "Schulungen",
      desc: "Hochwertige Schulungsangebote in unserem Trainingscenter oder bei sich vor Ort.",
    },
    external: {
      title: "Externe Schulungen",
      desc: "Prämienpunkte für Angebote von Drittanbieter nutzen und Kosten senken.",
    },
  },
  single: {
    done: "Training abgeschlossen.",
    doneDownloadCertificate: "Training abgeschlossen. Zertifikat herunterladen.",
  },
  certificate: {
    header: "ZERTIFIKAT",
    atCourse: "hat erfolgreich am Kurs",
    takePart: "teilgenommen.",
    contains: "BESTANDTEILE DES KURSES",
    country: "Österreich",
  },
  external: {
    title: "Externe Schulungen",
    description:
      "Sichern sie sich Expertenwissen und bei erfolgreicher Teilnahme an den jeweiligen Tests zum Training Ihr persönliches Teilnahme-Zertifikat sowie einmalig 40 Extrapunkte für den Prämienclub",
    additionalInfo:
      "Neben unseren kostenfreien Online-Trainings und den kostenpflichtigen Bridgestone Schulungen bieten wir Ihnen auch die Möglichkeit, externe Schulungen mit Ihren Prämienpunkten – je nach Ihrem Guthaben - zu finanzieren bzw. zu bezuschussen.",
    itsEasy: "So einfach geht es:",
    excludeText:
      "Bitte haben Sie Verständnis, dass Angebote des direkten Wettbewerbs ausgeschlossen sind.",
    downloadSection: {
      title: "Download Rechnungsvorlage",
      description1:
        "Laden Sie hier eine Vorlage für Ihre Punkteabrechnung an uns herunter.",
      description2: "Auf dem Beispiel finden Sie alle Angaben, die nötig sind.",
    },
    form: {
      title: "Antrag",
      thirdPartyInvoice: "Rechnung Drittanbieter",
      userInvoice: "Meine Rechnung",
      bankAccountOwner: "Kontoinhaber",
      uploadInvoice: "Meine Rechnung über die eingesetzten Punkte hochladen",
      have: "Ich möchte",
      thirdPartyInvoiceDesc:
        "Punkte in einem %{calculatePriceDiscount} EUR von für folgende",
      userInvoiceDesc:
        "Schulungsrechnung einsetzen, Rechnung Drittanbieter hochladen",
    },
    info: {
      paragraph1:
        " Sie nehmen selbst oder Ihre Team an einer fachlichen Schulung eines Drittanbieters teil.",
      paragraph2: "Sie gleichen die Rechnung des Drittanbieter aus.",
      paragraph3:
        "Sie stellen hier auf dieser Seite im Anfragefeld den Antrag auf Bezuschussung",
      elements: {
        first: "Rechnung des Drittanbieters hochladen",
        second:
          "Höhe der Punkte eintragen, die Sie einsetzen möchten (maximal in Höhe des Netto-Rechnungsbetrages)",
        third:
          "Sie erstellen eine Rechnung Ihres Betriebs in Höhe der eingesetzten Punkte (0,25 EUR netto pro Punkt) und laben diese ebenfalls hoch",
        fourth: "Die Rechnungen und der Antrag werden geprüft",
        fifth: "Sie erhalten eine Auszahlung in Höhe der eingesetzten Punkte",
      },
    },
    success: {
      title: "Vielen Dank",
      paragraph: {
        first: "Ihr Antrag ist eingegangen.",
        second:
          "Sie erhalten nach positiver Prüfung die Erstattung in Höhe der eingesetzten Punkte auf das angegeben Konto gutschrieben.",
        third:
          "Prüfung und Auszahlung können bis zu 6 Wochen in Anspruch nehmen.",
        fourth:
          "Ihr Punktekonto haben wir um die Höhe der eingesetzten Punkte reduziert.",
        fifth: "Eine Kopie des Antrags finden Sie in Ihrem",
      },
    },
  },
};

export default {
  messages,
};
